<template>
    <router-view></router-view>
</template>

<script>
    import store from './store/index'

    export default {
        name: 'APP',
        created() {
            window.addEventListener("beforeunload", () => {
                if (store.getters.token) {
                    localStorage.setItem('ul', JSON.stringify({
                        'email': store.getters.token,
                        'time': new Date().getTime()
                    }))
                }
            })
        }
    }
</script>
<style>
    .app-header {
        z-index: 100 !important;
    }
</style>



// WEBPACK FOOTER //
// App.vue?6c7acf10